/**
 * HelpAndSupportCard — pinned on the Dashboard with quick access to:
 *   • Demo video on YouTube
 *   • User Guide
 *   • WhatsApp Support (deep link)
 */
import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Play, BookOpen, MessageCircle } from "lucide-react";
import { buildWaLink } from "../lib/whatsappLink";

const DEMO_VIDEO_URL = "https://youtu.be/R1zJqvfzUpY";
const USER_GUIDE_URL = "https://myhisaabpro.com/guide";

export default function HelpAndSupportCard() {
  const [supportNumber, setSupportNumber] = useState("");

  useEffect(() => {
    api.get("/platform/whatsapp").then((r) => setSupportNumber(r.data?.support_number || "")).catch(() => {});
  }, []);

  const waLink = supportNumber
    ? buildWaLink(supportNumber, "Assalam o Alaikum HisaabPro team — mujhe support chahiye.")
    : null;

  const items = [
    {
      icon: Play,
      title: "Watch Demo Video",
      desc: "5-minute walkthrough of HisaabPro features",
      href: DEMO_VIDEO_URL,
      tone: "bg-red-50 border-red-200 text-red-700",
      testid: "help-demo-video",
    },
    {
      icon: BookOpen,
      title: "User Guide",
      desc: "Step-by-step instructions and best practices",
      href: USER_GUIDE_URL,
      tone: "bg-sky-50 border-sky-200 text-sky-700",
      testid: "help-user-guide",
    },
    {
      icon: MessageCircle,
      title: "WhatsApp Support",
      desc: supportNumber ? `Chat live on +${supportNumber.replace(/\D/g, "")}` : "Support team available 24/7",
      href: waLink || "#",
      tone: "bg-emerald-50 border-emerald-200 text-emerald-700",
      disabled: !waLink,
      testid: "help-wa-support",
    },
  ];

  return (
    <div className="bg-white border border-slate-200 rounded-md p-5" data-testid="help-support-card">
      <div className="font-display font-bold text-lg mb-3 flex items-center gap-2">
        <BookOpen className="w-5 h-5 text-emerald-600" /> Help &amp; Support
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {items.map((it) => (
          <a
            key={it.title}
            href={it.href}
            target={it.href.startsWith("http") ? "_blank" : undefined}
            rel="noreferrer"
            className={`flex items-start gap-3 rounded-md border p-3 hover:shadow-sm transition ${it.tone} ${it.disabled ? "opacity-50 pointer-events-none" : ""}`}
            data-testid={it.testid}
          >
            <it.icon className="w-5 h-5 mt-0.5 shrink-0" />
            <div className="text-sm">
              <div className="font-semibold">{it.title}</div>
              <div className="text-xs opacity-80 mt-0.5">{it.desc}</div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
